
define('text!templates/T1Apps.html',[],function () { return '<div class="main-content" id="appHeight">\n\t<div class="overlay-view-bg fixposition" style="left: 113px;"></div>\n\t<div class="main-column overlay-view routed-view">\n\t\t<div class="app-list-container"></div>\n\t\t<div class="routed-view"></div>\n\t</div>\n</div>\n';});

